export const ADMIN_DETAIL = "ADMIN_DETAIL";
export const SITE_MODE = "SITE_MODE";
